"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Footer_component_1 = require("./Footer.component");
exports.Footer = Footer_component_1.Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9TdHVkZW50U3RhdGlzdGljcy9wYXJ0cy9Gb290ZXIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx1REFBeUM7QUFBakMsb0NBQUEsTUFBTSxDQUFBIn0=